import React, {Component} from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { withStyles  } from '@mui/styles';
import { ArrowForwardIos } from '@mui/icons-material';

const styles = (theme) => ({
  root: {
    height: 30,
    padding: '7px 30px',
    width: '100%',
    fontSize: 13,
    backgroundColor: 'darkslategrey',
    boxShadow: 'inset 0px 11px 1px -10px rgba(0,0,0,0.5), ' +
      ' inset 0px -6px 3px -10px rgba(0,0,0,0.5)'
  },
  breadcrumbLink : {
    color: '#fff',
    textDecoration: 'none'
  },
  separator: {
    color: theme.palette.common.white,
    verticalAlign: 'text-top',
    height: 16,
    margin: '0px 3px'
  }
});

class Breadcrumbs extends Component {
    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
      this.unlisten = this.props.history.listen(() => {
        this.setState({
          pathChange: Math.random() // eslint-disable-line react/no-unused-state
        });
      });
    }

    componentWillUnmount() {
      this.unlisten();
    }

    render() {
      const { classes, placement, order } = this.props;
      let { advertiser } = this.props;
      if (!advertiser && order) {
        advertiser = order.Advertiser;
      }
      const routeWithPlacement = document.location.href.indexOf('placement') !== -1;
      const routeWithOrder = document.location.href.indexOf('ios') !== -1;
      const routeWithReports = document.location.href.indexOf('reports') !== -1;
      const routeWithAdvertiser = document.location.href.indexOf('ios') !== -1 ||
        document.location.href.indexOf('advertiser') !== -1;
      const routeWithCreateOrder = document.location.href.indexOf('ios/create') !== -1;
      const routeWithCreatePlacement = document.location.href.indexOf('placement/create') !== -1;

      const some = routeWithPlacement ||
        routeWithOrder ||
        routeWithReports ||
        routeWithCreateOrder ||
        routeWithCreatePlacement;

      return (
        <div>
          {some && (
          <div className={classes.root}>
            {routeWithReports && (
            <Link className={classes.breadcrumbLink} to="/reports">
                  Reports
            </Link>
            )}

            {routeWithAdvertiser && advertiser && advertiser.name && (
            <Link className={classes.breadcrumbLink} to={`/advertiser/${advertiser.id}`}>
              {advertiser.name}
            </Link>
            )}

            {order && order.agencyOrderName && routeWithOrder && !routeWithCreateOrder && (
              <span>
                <ArrowForwardIos className={classes.separator} />
                <Link className={classes.breadcrumbLink} to={`/ios/${order.id}`}>
                  {order.agencyOrderName}
                </Link>
              </span>
            )}

            {routeWithCreateOrder && (
              <span className={classes.breadcrumbLink}>
                <ArrowForwardIos className={classes.separator} />
                New Order
              </span>
            )}

            {
              placement && placement.agencyPlacementName &&
              routeWithPlacement &&
              !routeWithCreatePlacement && (
              <span>
                <ArrowForwardIos className={classes.separator} />
                <Link
                  className={classes.breadcrumbLink}
                  to={`/ios/${order.id}/placement/${placement.id}`}
                >
                  {placement.agencyPlacementName}
                </Link>
              </span>
              )
            }

            {
              routeWithCreatePlacement && (
              <span className={classes.breadcrumbLink}>
                <ArrowForwardIos className={classes.separator} />
                New Placement
              </span>
              )
            }
          </div>
          )}
        </div>
        )
      }
}

export default withRouter(withStyles(styles)(Breadcrumbs));
